import React                                                from "react";
import { TouchableWithoutFeedback, Text, View, StyleSheet } from "react-native";

import FilterButton                                         from "~/components/Buttons/FilterButton";
import Row                                                  from "~/layouts/Row";
import Col                                                  from "~/layouts/Col";
import palette                                              from "~/styles/palette";

export default function LineFilterBar({
  activeFilter = "all",
  onFilterChange,
}) {
  return (
    <View style={[styles.line_filter_bar__container]}>
      <Row pl={8} pr={8} style={[styles.line_filter_bar__inner]}>
        <FilterButton
          label="All"
          active={activeFilter === "all"}
          onPress={() => onFilterChange("all")}
        />
        <FilterButton
          label="Main"
          active={activeFilter === "assigned"}
          pl={4}
          onPress={() => onFilterChange("assigned")}
          pr={4}
        />
        <FilterButton
          label="Managed"
          active={activeFilter === "managed"}
          onPress={() => onFilterChange("managed")}
        />
      </Row>
    </View>
  );
}

const styles = StyleSheet.create({
  line_filter_bar__container: {},
  line_filter_bar__inner: {
    height: 45,
  },
});
